import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure, useToast
} from "@chakra-ui/react";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";

import { postRevisionCodes } from "../../shared/Api";
import { errorToast, successToast } from "../../shared/helper/ToastHelper";
import { adminKeys } from "../../shared/QueryKeys";
import { saveByteArray } from "../../shared/Utils";


/* TODO: make parameterized texts and api call */

const UploadExcelFeedback = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  const addUserTagsMutation = useMutation(postRevisionCodes,
    {
      onSuccess: (TData) => {
        successToast(toast, "Usuarios actualizados");
        saveByteArray("Usuarios actualizados", TData.data);
        return queryClient.invalidateQueries(adminKeys.users());
      },
      onError: (error) => {
        errorToast(toast, "Error actualizando usuarios");
      },
    } );

  function handleClick() {
    if (file) {
      addUserTagsMutation.mutate(file);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme="teal" onClick={onOpen}>
        Agregar códigos
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Agregar códigos</ModalHeader>
          <ModalBody>
            <FormControl id="file-form-control" paddingBottom="6">
              <FormLabel>Códigos</FormLabel>
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                Seleccione un archivo en formato xlsx.
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalCloseButton />
          <ModalFooter>
            <Button
                colorScheme="teal"
                type="submit"
                isDisabled={!file}
                onClick={handleClick}
            >
              Crear
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UploadExcelFeedback;